import React, { useContext } from 'react';

import { ListItemIcon } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripDotsVertical } from '@fortawesome/sharp-regular-svg-icons';
import { SortableItemContext } from './SortableItemContext';

export const DragHandle: React.FunctionComponent = function () {
    const { attributes, listeners, ref } = useContext(SortableItemContext);

    return (
        <ListItemIcon
            {...attributes}
            {...listeners}
            ref={ref}
            className="DragHandle"
        >
            <FontAwesomeIcon
                icon={faGripDotsVertical}
                size="lg"
            />
        </ListItemIcon>
    );
};
